import LoginModal from './index'

export default {
  LoginModal,
}
